import React, { useState } from "react";
import "./IntegrationAPIEndPoints.css";
import { APIEndPoints } from "../../Utils/constants";
import { Form, Input } from "antd";
import { CheckCircleTwoTone, copy } from "../../Utils/imports";
import { APIRestPointsVar } from "../../Utils/variables";
import { useRef } from "react";

const { heading } = APIRestPointsVar;

const IntegrationAPIRestPoints = () => {

  const [copied, setCopied] = useState({
    flag: false,
    value: null
  })
  function copyText(id) {
    var copyText = document.getElementById(`input${id}`);

    navigator.clipboard.writeText(copyText.value);
    setTimeout(() => {
      setCopied({ flag: false, value: null })
    }, 1000);
    setCopied({ flag: true, value: id })
  }


  const RestAPIEndPoints = APIEndPoints.map((endpoint, index) => (
    <Form.Item
      key={endpoint.id}
      label={
        <div className="dflex alignCenter">
          <p className="IARP-form-label">{endpoint.title}</p>
          <img src={copy} className="copy-icon" onClick={() => copyText(endpoint.id)} />
          {
            copied.flag ? <>{endpoint.id === copied.value ? <> <span style={{ fontSize: "12px" }}>&nbsp;&nbsp;Copied&nbsp;<CheckCircleTwoTone twoToneColor="#52c41a" /></span>  </> : <></>}</> : <></>
          }

        </div>
      }
      name={endpoint.title}
    >
      <Input
        className="IARP-form-input boxBorder boxBorderRad boxBg"
        defaultValue={endpoint.data}
        readOnly={true}
        id={`input${endpoint.id}`}
      />
    </Form.Item>
  ));
  return (
    <div className="APIRestPoints-div1 boxBorderRad boxBorder p10">
      <h1 className="APIRestPoints-div1-h1">{heading}</h1>
      <Form name="basic" layout="vertical">
        {RestAPIEndPoints}
      </Form>
    </div>
  );
};

export default IntegrationAPIRestPoints;
